import React from 'react';
import { Link } from 'react-router-dom';

const DisclosurePage: React.FC = () => {
  return (
    <div style={{ padding: '2rem 0' }}>
      <div className="container">
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Breadcrumb */}
          <div style={{ marginBottom: 'var(--space-lg)' }}>
            <Link to="/" style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>
              ← Back to Home
            </Link>
          </div>

          <h1 style={{ marginBottom: 'var(--space-xl)' }}>Affiliate & Partner Disclosure</h1>

          <div style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
            <p style={{ marginBottom: 'var(--space-lg)' }}>
              At ChooseAI, our mission is to help founders, decision-makers, and creators navigate the AI landscape with clarity. To keep our resources free and our "ChooseTools" database up to date, we participate in several affiliate marketing programs.
            </p>

            <h2 style={{ marginTop: 'var(--space-xl)', marginBottom: 'var(--space-md)' }}>What This Means for You</h2>
            <p style={{ marginBottom: 'var(--space-lg)' }}>
              When you click on certain links or buttons that link externally, we may receive a commission or referral fee from our partners.
            </p>

            <p style={{ marginBottom: 'var(--space-sm)' }}>It is important to note:</p>
            <ul style={{ marginBottom: 'var(--space-lg)', paddingLeft: '2rem' }}>
              <li style={{ marginBottom: 'var(--space-sm)' }}>
                <strong>No extra cost:</strong> This commission comes at no additional expense to you. In some cases, our partnerships allow us to provide exclusive discounts or extended trials.
              </li>
              <li style={{ marginBottom: 'var(--space-sm)' }}>
                <strong>Objective focus:</strong> While we prioritise references to our partner tools (such as those listed in our primary Tool List), our content is driven by real use cases and comparisons designed to help you build the right AI stack for your specific needs.
              </li>
              <li style={{ marginBottom: 'var(--space-sm)' }}>
                <strong>Transparency:</strong> We only promote tools and services that we believe provide genuine value to our audience.
              </li>
            </ul>

            <h2 style={{ marginTop: 'var(--space-xl)', marginBottom: 'var(--space-md)' }}>Why We Use This Model</h2>
            <p style={{ marginBottom: 'var(--space-lg)' }}>
              This model allows us to invest get hands on with the tools we discuss to ensure you are getting the most relevant, current information available in the fast-moving AI sector.
            </p>

            <h2 style={{ marginTop: 'var(--space-xl)', marginBottom: 'var(--space-md)' }}>Questions?</h2>
            <p style={{ marginBottom: 'var(--space-xl)' }}>
              Your trust is our most important asset. If you have any questions regarding our affiliate relationships or how we evaluate tools, please feel free to reach out to us directly.
            </p>

            <div style={{ textAlign: 'center', marginTop: 'var(--space-xl)' }}>
              <Link to="/" className="button button-primary">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclosurePage;
